import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { checkAuth } from '../../utils/auth';

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState('loading');
  const location = useLocation();

  useEffect(() => {
    let active = true;

    const verify = async () => {
      const result = await checkAuth();

      if (!active) return;
      setStatus(result.authenticated ? 'authed' : 'guest');
    };

    verify();

    return () => {
      active = false;
    };
  }, [location.pathname]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-wabi-cream-100">
        <Spin size="large" />
      </div>
    );
  }

  if (status === 'guest') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;
